import Services from 'mpm-services';
import { AUTH_LOGOUT, SET_USER_DATA, SET_TOGGLE_MENU } from '../Constants';


const setUserData = (data, state) => {
    state = { ...state, isAuthenticated: true, connectedUser: data };
    return state;
};

const logout = (data, state) => {
    Services.UserDataService.saveDateLogout(state.connectedUser.login);
    window.keycloak.logout();
    sessionStorage.removeItem("react-token");
    sessionStorage.removeItem("react-refresh-token");
    state = { ...state, isAuthenticated: false, connectedUser: {} };
    return state;
};

const toggleMenu = (data, state) => {
    state = { ...state, bigMenu: !state.bigMenu }
    return state;
}

export const MPMReducer = (state, action) => {
    switch (action.type) {
        case SET_USER_DATA: return setUserData(action.data, state);
        case AUTH_LOGOUT: return logout(action.data, state);
        case SET_TOGGLE_MENU: return toggleMenu(action.data, state);
        default:
            return state;
    }
};